
import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import TerminalRoundedIcon from '@mui/icons-material/TerminalRounded';
import ApiRoundedIcon from '@mui/icons-material/ApiRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Sdk() {
  React.useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 14 },
        bgcolor: '#8b261d', // Rojo tipo ladrillo
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Elementos decorativos de fondo */}
      <Box
        sx={{
          position: 'absolute',
          top: -100,
          right: -100,
          width: 400,
          height: 400,
          bgcolor: 'rgba(255,255,255,0.05)',
          borderRadius: '50%',
          filter: 'blur(60px)',
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={6} alignItems="center">
          
          {/* Columna Izquierda: Copy y CTA */}
          <Grid item xs={12} md={6} data-aos="fade-right">
            <Typography
              variant="overline"
              sx={{ color: 'rgba(255,255,255,0.7)', fontWeight: 'bold', letterSpacing: 2 }}
            >
              PARA DESARROLLADORES
            </Typography>
            
            <Typography variant="h3" component="h2" fontWeight="bold" sx={{ mt: 1, mb: 3 }}>
              Construye más rápido con el SDK E-Commerce
            </Typography>
            
            <Typography variant="body1" sx={{ color: 'grey.300', mb: 4, fontSize: '1.1rem', lineHeight: 1.6 }}>
              Integra nuestro motor multi-tenant en tu aplicación React o Node.js en minutos. 
              Gestiona usuarios, aprovisiona aplicaciones y autentica sesiones de forma segura 
              con firmas RSA de grado empresarial.
            </Typography>

            <Stack direction="row" spacing={3} sx={{ mb: 5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ApiRoundedIcon sx={{ color: 'grey.300' }} />
                <Typography variant="body2" fontWeight="medium">API Tipada (TS)</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SecurityRoundedIcon sx={{ color: 'grey.300' }} />
                <Typography variant="body2" fontWeight="medium">M2M RSA Auth</Typography>
              </Box>
            </Stack>

            <Button
              component={RouterLink}
              to="/documentation"
              variant="contained"
              endIcon={<ArrowForwardRoundedIcon />}
              sx={{
                bgcolor: 'white',
                color: '#8b261d',
                px: 4,
                py: 1.5,
                fontWeight: 'bold',
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1rem',
                boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                '&:hover': {
                  bgcolor: 'grey.100',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.3)',
                },
              }}
            >
              Ver Documentación
            </Button>
          </Grid>

          {/* Columna Derecha: Ventana de Código Mockup */}
          <Grid item xs={12} md={6} data-aos="fade-left" data-aos-delay="200">
            <Box
              sx={{
                bgcolor: '#0d1117', // Color oscuro estilo terminal/GitHub
                borderRadius: 3,
                p: 3,
                border: '1px solid rgba(255,255,255,0.1)',
                boxShadow: '0 24px 48px rgba(0,0,0,0.4)',
              }}
            >
              {/* Botones estilo macOS */}
              <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
                <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#ff5f56' }} />
                <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#ffbd2e' }} />
                <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#27c93f' }} />
              </Stack>

              {/* Código */}
              <Box sx={{ fontFamily: 'monospace', fontSize: '0.85rem', lineHeight: 1.7 }}>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2, color: 'grey.400' }}>
                  <TerminalRoundedIcon fontSize="small" />
                  <Typography variant="inherit">bash</Typography>
                </Stack>
                
                <Typography variant="inherit" sx={{ color: '#c9d1d9', mb: 3 }}>
                  <span style={{ color: '#79c0ff' }}>npm</span> install @leidenfrost/sdk
                </Typography>

                <Typography variant="inherit" sx={{ color: '#8b949e', mb: 1 }}>
                  // Inicializa el cliente
                </Typography>
                <Typography variant="inherit" sx={{ color: '#c9d1d9' }}>
                  <span style={{ color: '#ff7b72' }}>import</span> {'{ Leidenfrost }'} <span style={{ color: '#ff7b72' }}>from</span> <span style={{ color: '#a5d6ff' }}>"@leidenfrost/sdk"</span>;
                </Typography>
                <br />
                <Typography variant="inherit" sx={{ color: '#c9d1d9' }}>
                  <span style={{ color: '#ff7b72' }}>const</span> lf = Leidenfrost.<span style={{ color: '#d2a8ff' }}>initializeApp</span>({'{'}
                </Typography>
                <Typography variant="inherit" sx={{ color: '#c9d1d9', pl: 2 }}>
                  clientId: <span style={{ color: '#a5d6ff' }}>"sa_master_messiah"</span>,
                </Typography>
                <Typography variant="inherit" sx={{ color: '#c9d1d9', pl: 2 }}>
                  privateKey: <span style={{ color: '#a5d6ff' }}>"-----BEGIN PRIVATE KEY..."</span>
                </Typography>
                <Typography variant="inherit" sx={{ color: '#c9d1d9' }}>
                  {'}'});
                </Typography>
              </Box>
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}